import { useTranslation, Trans } from "react-i18next";

/**
 * Help page component explaining how to create a new Sheet Agent run.
 * Includes instructions about uploading documents first.
 *
 * @component
 */
function HelpPageCreateRun() {
  const { t } = useTranslation("modals");

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h2 className="text-xl font-semibold">{t("sheetagent.help.createrun.title")}</h2>
        <p className="text-sm text-muted-foreground">
          {t("sheetagent.help.createrun.description")}
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.createrun.step1title")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            <Trans
              i18nKey="sheetagent.help.createrun.step1description"
              ns="modals"
              components={{
                strong: <strong className="text-foreground" />,
              }}
            />
          </p>
          <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1 ml-2">
            <li>{t("sheetagent.help.createrun.step1list1")}</li>
            <li>{t("sheetagent.help.createrun.step1list2")}</li>
            <li>{t("sheetagent.help.createrun.step1list3")}</li>
          </ul>
        </div>

        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.createrun.step2title")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {t("sheetagent.help.createrun.step2description")}
          </p>
          <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1 ml-2">
            <li>
              <strong className="text-foreground">{t("sheetagent.help.createrun.step2list1name")}</strong>{" "}
              {t("sheetagent.help.createrun.step2list1value")}
            </li>
            <li>
              <strong className="text-foreground">{t("sheetagent.help.createrun.step2list2name")}</strong>{" "}
              {t("sheetagent.help.createrun.step2list2value")}
            </li>
            <li>
              <strong className="text-foreground">{t("sheetagent.help.createrun.step2list3name")}</strong>{" "}
              {t("sheetagent.help.createrun.step2list3value")}
            </li>
          </ul>
        </div>

        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.createrun.step3title")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {t("sheetagent.help.createrun.step3description")}
          </p>
        </div>
      </div>

      <div className="p-4 bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-md">
        <p className="text-sm text-amber-900 dark:text-amber-100">
          <strong className="font-medium">{t("sheetagent.help.createrun.importanttitle")}</strong>{" "}
          {t("sheetagent.help.createrun.importantcontent")}
        </p>
      </div>
    </div>
  );
}

export default HelpPageCreateRun;
